import { Table, Button, Row, Col, Space } from 'antd/lib';
import * as Icons from '@ant-design/icons';
import React from 'react';
import moment from 'moment';
import _ from 'lodash';

class TablaCertificacionesTraspaso extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      filterDropdownVisible: false,
      data: this.props.certificacionesTraspaso,
      filtered: false,
    };
  }

  render() {
    const columns = [
      {
        title: 'N° Traspaso',
        key: 'numero',
        render: certificacion =>
          certificacion.traspaso.numero ? certificacion.traspaso.numero : '-',
      },
      {
        title: 'Fecha Desde',
        key: 'fechaDesde',
        render: certificacion =>
          certificacion.fechaDesde
            ? moment(certificacion.fechaDesde).format('DD/MM/YYYY HH:mm')
            : '-',
      },
      {
        title: 'Fecha Hasta',
        key: 'fechaHasta',
        render: certificacion =>
          certificacion.fechaHasta
            ? moment(certificacion.fechaHasta).format('DD/MM/YYYY HH:mm')
            : '-',
      },
      {
        title: 'Estado',
        dataIndex: 'estado',
        render: estado => estado.toUpperCase(),
      },
      {
        title: 'Pago Viaticos',
        key: 'pagoViaticos',
        render: certificacion =>
          certificacion.pagoViaticos ? (
            <Icons.CheckOutlined style={{ color: '#52c41a' }} />
          ) : (
            <Icons.CloseOutlined style={{ color: '#eb2f96' }} />
          ),
      },
      {
        title: 'Resolucion',
        key: 'resolucion',
        render: certificacion => (
          <Space>
            <Button
              icon={<Icons.FileSearchOutlined />}
              disabled={!certificacion.resolucion.archivoId}
              onClick={() =>
                this.props.getBase64(certificacion.resolucion.archivoId)
              }
              target={'_blank'}
            />
          </Space>
        ),
      },
      {
        title: 'Acciones',
        key: 'acciones',
        render: (text, record) => (
          <Space>
            <Button
              type="danger"
              icon={<Icons.CloseCircleOutlined />}
              onClick={() => this.props.eliminarCertificacion(record._id)}
              disabled={record.estado !== 'PRECARGADO'}
            />
            <Button
              type="primary"
              icon={<Icons.EditOutlined />}
              onClick={() =>
                this.props.history.push(
                  `/rrhh/certificacionTraspaso/${record._id}/editar`
                )
              }
              disabled={record.estado !== 'PRECARGADO'}
            />
          </Space>
        ),
      },
    ];
    const { certificacionesTraspaso } = this.props;
    return (
      <Table
        rowKey="_id"
        bordered
        size="small"
        columns={columns}
        dataSource={certificacionesTraspaso}
        pagination={false}
        loading={this.props.loadingTabla}
        title={() => (
          <Row>
            <Col offset={8} span={8}>
              <h3 style={{ textAlign: 'center', marginTop: 5 }}>
                Certificaciones
              </h3>
            </Col>
          </Row>
        )}
        locale={{
          emptyText: 'Sin certificaciones cargadas.',
        }}
      />
    );
  }
}

export default TablaCertificacionesTraspaso;
